export default __webpack_public_path__ + "static/media/filter.c21302d2.svg";